export default __webpack_public_path__ + "static/media/campus (5).ff370b9a.jpg";